import { useState, useRef, useEffect } from 'react'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { customerApi } from '../../services/api'
import toast from 'react-hot-toast'

export default function ExportButton({ period }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [])

  const handleExport = async (type) => {
    setOpen(false)
    try {
      const response = await customerApi.get(`/customer/analytics/export?period=${period}&type=${type}`, {
        responseType: 'blob',
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const a = document.createElement('a')
      a.href = url
      a.download = `cognaassist_analytics_${type}_${period}.csv`
      a.click()
      window.URL.revokeObjectURL(url)
      toast.success(`${type} exported successfully`)
    } catch (err) {
      toast.error('Export failed')
    }
  }

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center space-x-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
      >
        <ArrowDownTrayIcon className="h-3.5 w-3.5" />
        <span>Export</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-40 bg-white border border-slate-200 rounded-lg shadow-lg z-10 py-1">
          {['conversations', 'messages', 'summary'].map((type) => (
            <button
              key={type}
              onClick={() => handleExport(type)}
              className="w-full text-left px-3 py-2 text-xs text-slate-700 hover:bg-slate-50 capitalize"
            >
              {type}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
